import { Reducer } from 'redux'
import { ASSET_ACTIONS } from './const'
import { Account, ActionTypes, STATE_STATUS } from './types'

export type State = {
  accountList: Account[]
  isAccountListInitiated: boolean
  totalBalance: string
  status: STATE_STATUS
}

const initialState: State = {
  accountList: [],
  isAccountListInitiated: false,
  status: STATE_STATUS.IDLE,
  totalBalance: '0',
}

export const assets: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case ASSET_ACTIONS.RESET_ASSET_LIST: {
      return {
        ...state,
        accountList: [],
      }
    }

    case ASSET_ACTIONS.SET_ASSET_LIST: {
      return {
        ...state,
        accountList: action.accountList,
        isAccountListInitiated: true,
        status: STATE_STATUS.SUCCESS,
        totalBalance: action.totalBalance,
      }
    }

    case ASSET_ACTIONS.SET_ERROR_STATE: {
      return {
        ...state,
        status: STATE_STATUS.ERROR,
      }
    }

    case ASSET_ACTIONS.SET_LOADING_STATE: {
      return {
        ...state,
        status: STATE_STATUS.LOADING,
      }
    }

    default:
      return state
  }
}
